module.exports = "<content class=\"inner-scroll\">\n    <router-outlet></router-outlet>\n</content>"